import moment from "moment";
import { SuggestedDate } from "./types";
export class PlanMessageModalScripts {
   static splitDateTimeToTimestamp = (dateTimeString: string): number | null => {
      const date = moment(dateTimeString, "YYYY-MM-DD HH:mm:ss");
      const timestamp = date.isValid() ? date.valueOf() : null;

      return timestamp;
   };

   static outOfPlannerHours = (plannerSettings) => {
      const format = "HH:mm:ss";
      const minHour = moment(plannerSettings.minTime, format).hour();
      const maxHour = moment(plannerSettings.maxTime, format).hour();

      const disabledHours: number[] = [];
      for (let i = 0; i < 24; i++) {
         if (i < minHour || i > maxHour) {
            disabledHours.push(i);
         }
      }
      return disabledHours;
   };

   static updateTimeUsedToday = (time: number, setTimeUsedToday) => {
      const integerPartOfTime = Math.floor(time);
      const decimalPartOfTime = ((time % 1) * 60).toFixed(0).toString().padStart(2, "0");

      setTimeUsedToday(`${integerPartOfTime}:${decimalPartOfTime}`);
   };

   static createSuggestedDatesFromResponse = (
      res,
      actionType: number,
      currentSuggestedDates: SuggestedDate[],
   ) => {
      if (actionType === 0) {
         return [
            ...res?.data?.getSuggestedDates?.previousFreeSlots,
            {
               suggestedDate: res?.data?.getSuggestedDates?.suggestedDate,
               suggestedTime: res?.data?.getSuggestedDates?.suggestedTime,
            },
            ...res?.data?.getSuggestedDates?.futureFreeSlots,
         ];
      } else if (actionType === 1) {
         return [...currentSuggestedDates, ...res.data?.getSuggestedDates?.futureFreeSlots];
      } else {
         return [...res.data?.getSuggestedDates?.previousFreeSlots, ...currentSuggestedDates];
      }
   };
}
